module.exports = __webpack_public_path__ + "img/building-50.633fbbce.svg";